var _mask, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 74,
    viewBox: "0 0 29 74",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_7359_41924",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.0175781V17.9892V18.0176V55.9827V55.9892V73.9827L0.0769095 66.8224C0.141273 60.8301 5.00745 56.0011 11 55.9827H10.5013C20.763 55.7169 29 47.3149 29 36.9892C29 26.5838 20.6356 18.1321 10.2638 17.9909C4.61382 17.5984 0.138615 12.9227 0.0769095 7.17789L0 0.0175781Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.0175781V17.9892V18.0176V55.9827V55.9892V73.9827L0.0769095 66.8224C0.141273 60.8301 5.00745 56.0011 11 55.9827H10.5013C20.763 55.7169 29 47.3149 29 36.9892C29 26.5838 20.6356 18.1321 10.2638 17.9909C4.61382 17.5984 0.138615 12.9227 0.0769095 7.17789L0 0.0175781Z",
    fill: "url(#paint0_linear_7359_41924)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.0175781L0.499971 0.0122079L-0.5 0.0175781H0ZM0 73.9827H-0.5L0.499971 73.988L0 73.9827ZM0.0769095 66.8224L0.576881 66.8277L0.0769095 66.8224ZM11 55.9827L11.0015 56.4827L11 55.4827V55.9827ZM10.5013 55.9827L10.4884 55.4828L10.5013 56.4827V55.9827ZM10.2638 17.9909L10.2291 18.4897L10.2431 18.4907L10.257 18.4909L10.2638 17.9909ZM0.0769095 7.17789L-0.423062 7.18326L0.0769095 7.17789ZM0.5 17.9892V0.0175781H-0.5V17.9892H0.5ZM0.5 18.0176V17.9892H-0.5V18.0176H0.5ZM0.5 55.9827V18.0176H-0.5V55.9827H0.5ZM-0.5 55.9827V55.9892H0.5V55.9827H-0.5ZM-0.5 55.9892V73.9827H0.5V55.9892H-0.5ZM0.499971 73.988L0.576881 66.8277L-0.423062 66.817L-0.499971 73.9773L0.499971 73.988ZM0.576881 66.8277C0.638307 61.1089 5.28243 56.5003 11.0015 56.4827L10.9985 55.4827C4.73246 55.5019 -0.355762 60.5513 -0.423062 66.817L0.576881 66.8277ZM11 55.4827H10.5013V56.4827H11V55.4827ZM28.5 36.9892C28.5 47.0431 20.4798 55.224 10.4884 55.4828L10.5143 56.4825C21.0463 56.2097 29.5 47.5867 29.5 36.9892H28.5ZM10.257 18.4909C20.3557 18.6283 28.5 26.8577 28.5 36.9892H29.5C29.5 26.31 20.9155 17.6359 10.2706 17.491L10.257 18.4909ZM-0.423062 7.18326C-0.358538 13.1904 4.32089 18.0793 10.2291 18.4897L10.2984 17.4922C4.90676 17.1176 0.635769 12.655 0.576881 7.17252L-0.423062 7.18326ZM-0.499971 0.0229484L-0.423062 7.18326L0.576881 7.17252L0.499971 0.0122079L-0.499971 0.0229484Z",
    fill: "white",
    fillOpacity: 0.1,
    mask: "url(#path-1-inside-1_7359_41924)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7359_41924",
    x1: -7.61519e-9,
    y1: 36.0006,
    x2: 29,
    y2: 36.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#584BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#905CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton);
export default __webpack_public_path__ + "static/media/button.3bb20f389d6ddc90ce651cb64050d921.svg";
export { ForwardRef as ReactComponent };